<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import {FormContact} from "@/domains/home/services/nir/forms/components/widgets/types";

const props = defineProps({
  data: {
    type: Array as () => FormContact[],
  }
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: FormContact[]): void
}>()

// Single contact mode
const singleContact = ref<FormContact>({
  email: '',
  phone: ''
})

// Multiple contacts mode
const multipleContacts = ref<FormContact[]>([
  { email: '', phone: '' }
])

function addContact() {
  multipleContacts.value.push({ email: '', phone: '' })
}

function removeContact(index: number) {
  if (multipleContacts.value.length > 1) {
    multipleContacts.value.splice(index, 1)
  }
}
</script>

<template>
<div class="flex flex-col">
  <div v-if="data && data.length > 0" class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg">
      <thead class="bg-gray-50">
        <tr>
          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            #
          </th>
          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Email
          </th>
          <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Phone
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="(contact, index) in data" :key="index" class="hover:bg-gray-50">
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
            {{ index + 1 }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
            <div class="flex items-center">
              <i class="fa fa-envelope text-gray-400 mr-2"></i>
              {{ contact.email || '-' }}
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
            <div class="flex items-center">
              <i class="fa fa-phone text-gray-400 mr-2"></i>
              {{ contact.phone || '-' }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else class="text-center py-8 text-gray-500 text-sm">
    <i class="fa fa-inbox text-3xl mb-2"></i>
    <p>No contact information available</p>
  </div>
</div>
</template>

<style scoped></style>
